
import { Link } from 'react-router-dom';
import PageHero from '../../../components/base/PageHero';

export default function ProgrammesHeroSection() {
  return (
    <PageHero
      breadcrumb="Programmes"
      label="QCTO Accredited"
      title="Nationally Recognised Training Programmes"
      description="Explore our full range of accredited programmes designed to advance careers, unlock SETA funding, and build lasting capability across your organisation."
      bgImage="/programmes-hero-campus.png"
    >
      <Link to="/contact"><button className="btn btn-white">Enrol Now <i className="ri-arrow-right-line ml-2" /></button></Link>
      <Link to="/resources"><button className="btn btn-ghost">Download Catalogue</button></Link>
    </PageHero>
  );
}
